'use strict';

import angular from 'angular';

/**
 * VideothequeCController - contrôleur de la page vidéothèque
 * Ce contrôleur gère l'affichage des vidéos depuis la chaîne YouTube OTFIP
 */
// Directive pour gérer les dropdowns de partage
angular.module('observatoireApp').directive('shareDropdown', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      // Montrer/cacher le menu au clic
      element.find('.dropdown-toggle').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Toggle l'état du dropdown
        element.toggleClass('show');
        element.find('.share-menu').toggleClass('show');
      });
      
      // Fermer le menu quand on clique ailleurs
      $(document).on('click', function(e) {
        if (!element[0].contains(e.target)) {
          element.removeClass('show');
          element.find('.share-menu').removeClass('show');
        }
      });
    }
  };
});

export default angular.module('observatoireApp')
  .controller('VideothequeController', ['$scope', '$http', '$sce', '$timeout', 'VideothequeService',
    function($scope, $http, $sce, $timeout, VideothequeService) {
      // État de chargement
      $scope.loading = true;
      $scope.error = null;
      
      // Vidéos et vidéo sélectionnée
      $scope.videos = [];
      $scope.videoSelectionnee = null;
      $scope.categories = [];
      $scope.annees = [];
      
      // Favoris
      $scope.videosFavorites = [];
      
      // Affichage des filtres avancés
      $scope.afficherFiltresAvances = false;
      
      // Filtres
      $scope.filtres = {
        categorie: '',
        texte: '',
        annee: '',
        mois: '',
        duree: '',
        favoris: false
      };
      
      // Pagination
      $scope.pagination = {
        pageCourante: 1,
        elementsParPage: 6,
        nombrePages: 1
      };
      
      // Math pour les calculs dans le template
      $scope.Math = window.Math;
      
      // Mode d'affichage (grille ou liste)
      $scope.modeAffichage = 'grille'; // Mode par défaut
      
      /**
       * Vérifie si une vidéo est en favori
       */
      $scope.estFavori = function(videoId) {
        return VideothequeService.estFavori(videoId);
      };
      
      /**
       * Ajoute ou supprime une vidéo des favoris
       */
      $scope.toggleFavori = function(videoId, event) {
        // Empêcher la propagation pour éviter d'ouvrir la vidéo
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        
        const estFavori = VideothequeService.toggleFavori(videoId);
        
        // Mettre à jour l'affichage si on est en mode favoris uniquement
        if ($scope.filtres.favoris) {
          filtrerVideos();
        }
        
        return estFavori;
      };
      
      /**
       * Télécharge une vidéo
       */
      $scope.telechargerVideo = function(video, event) {
        // Empêcher la propagation pour éviter d'ouvrir la vidéo
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        
        VideothequeService.telechargerVideo(video);
      };
      
      /**
       * Vérifie si une vidéo est téléchargeable
       */
      $scope.estTelechargeable = function(video) {
        return video && video.downloadable === true;
      };
      
      /**
       * Change le mode d'affichage entre grille et liste
       */
      $scope.changerModeAffichage = function(mode) {
        if (mode === 'grille' || mode === 'liste') {
          $scope.modeAffichage = mode;
          
          // Sauvegarde de la préférence utilisateur en local storage
          try {
            localStorage.setItem('videotheque.modeAffichage', mode);
          } catch (e) {
            console.warn('Impossible de sauvegarder le mode d\'affichage:', e);
          }
        }
      };
      
      // Récupérer le mode d'affichage sauvegardé
      try {
        const modeSauvegarde = localStorage.getItem('videotheque.modeAffichage');
        if (modeSauvegarde === 'grille' || modeSauvegarde === 'liste') {
          $scope.modeAffichage = modeSauvegarde;
        }
      } catch (e) {
        console.warn('Impossible de récupérer le mode d\'affichage:', e);
      }
      
      // Initialisation
      loadVideos();
      
      /**
       * Charge les vidéos de la chaîne YouTube
       */
      function loadVideos() {
        $scope.loading = true;
        
        VideothequeService.getVideos()
          .then(function(data) {
            $scope.videos = data;
            
            // Extraire les catégories uniques
            extractCategories();
            
            // Extraire les années uniques
            extractAnnees();
            
            // Appliquer le filtrage initial
            filtrerVideos();
            
            $scope.loading = false;
          })
          .catch(function(error) {
            console.error('Erreur lors du chargement des vidéos:', error);
            $scope.error = 'Impossible de charger les vidéos. Veuillez réessayer plus tard.';
            $scope.loading = false;
          });
      }
      
      /**
       * Extrait les catégories uniques depuis les vidéos
       */
      function extractCategories() {
        let categoriesSet = new Set();
        $scope.videos.forEach(function(video) {
          if (video.categorie) {
            categoriesSet.add(video.categorie);
          }
        });
        $scope.categories = Array.from(categoriesSet).sort();
      }
      
      /**
       * Extrait les années uniques depuis les dates des vidéos
       */
      function extractAnnees() {
        let anneesSet = new Set();
        $scope.videos.forEach(function(video) {
          if (video.date) {
            const annee = video.date.split('-')[0];
            if (annee) {
              anneesSet.add(annee);
            }
          }
        });
        $scope.annees = Array.from(anneesSet).sort().reverse(); // Trier par ordre décroissant (plus récent d'abord)
      }
      
      /**
       * Filtre les vidéos selon les critères de recherche
       */
      $scope.filtrerVideos = function() {
        // Réinitialiser la pagination
        $scope.pagination.pageCourante = 1;
        
        filtrerVideos();
      };
      
      /**
       * Affiche ou masque les filtres avancés
       */
      $scope.toggleFiltresAvances = function() {
        $scope.afficherFiltresAvances = !$scope.afficherFiltresAvances;
      };
      
      /**
       * Filtre les vidéos selon tous les critères
       */
      function filtrerVideos() {
        let videosFiltrees = $scope.videos;
        
        // Si on veut voir uniquement les favoris
        if ($scope.filtres.favoris) {
          videosFiltrees = videosFiltrees.filter(function(video) {
            return VideothequeService.estFavori(video.videoId);
          });
        }
        
        // Filtre par catégorie
        if ($scope.filtres.categorie) {
          videosFiltrees = videosFiltrees.filter(function(video) {
            return video.categorie === $scope.filtres.categorie;
          });
        }
        
        // Filtre par texte (recherche dans le titre et la description)
        if ($scope.filtres.texte) {
          const texteFiltre = $scope.filtres.texte.toLowerCase();
          videosFiltrees = videosFiltrees.filter(function(video) {
            return (
              (video.titre && video.titre.toLowerCase().includes(texteFiltre)) ||
              (video.description && video.description.toLowerCase().includes(texteFiltre))
            );
          });
        }
        
        // Filtre par année
        if ($scope.filtres.annee) {
          videosFiltrees = videosFiltrees.filter(function(video) {
            if (!video.date) return false;
            return video.date.startsWith($scope.filtres.annee);
          });
        }
        
        // Filtre par mois (ne s'applique que si une année est sélectionnée)
        if ($scope.filtres.annee && $scope.filtres.mois) {
          videosFiltrees = videosFiltrees.filter(function(video) {
            if (!video.date) return false;
            // Format de date attendu: YYYY-MM-DD
            const yearMonth = $scope.filtres.annee + '-' + $scope.filtres.mois;
            return video.date.startsWith(yearMonth);
          });
        }
        
        // Filtre par durée
        if ($scope.filtres.duree) {
          videosFiltrees = videosFiltrees.filter(function(video) {
            if (!video.duree) return false;
            
            // Convertir la durée (format HH:MM:SS ou MM:SS) en minutes
            const parts = video.duree.split(':');
            let minutes = 0;
            
            if (parts.length === 3) { // Format HH:MM:SS
              minutes = parseInt(parts[0]) * 60 + parseInt(parts[1]);
            } else if (parts.length === 2) { // Format MM:SS
              minutes = parseInt(parts[0]);
            }
            
            // Filtrer selon la durée
            switch($scope.filtres.duree) {
              case 'court':
                return minutes < 10;
              case 'moyen':
                return minutes >= 10 && minutes <= 30;
              case 'long':
                return minutes > 30;
              default:
                return true;
            }
          });
        }
        
        $scope.videosFiltrees = videosFiltrees;
        
        // Mettre à jour la pagination
        updatePagination();
      }
      
      /**
       * Met à jour la pagination
       */
      function updatePagination() {
        $scope.pagination.nombrePages = Math.ceil($scope.videosFiltrees.length / $scope.pagination.elementsParPage);
        if ($scope.pagination.pageCourante > $scope.pagination.nombrePages) {
          $scope.pagination.pageCourante = 1;
        }
      }
      
      /**
       * Change de page
       */
      $scope.changerPage = function(page) {
        if (page >= 1 && page <= $scope.pagination.nombrePages) {
          $scope.pagination.pageCourante = page;
        }
      };
      
      /**
       * Génère la liste des pages à afficher dans la pagination
       */
      $scope.getPages = function() {
        let pages = [];
        let startPage = Math.max(1, $scope.pagination.pageCourante - 2);
        let endPage = Math.min($scope.pagination.nombrePages, startPage + 4);
        
        // Ajuster startPage si on est près de la fin
        if (endPage - startPage < 4) {
          startPage = Math.max(1, endPage - 4);
        }
        
        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
        
        return pages;
      };
      
      /**
       * Affiche une vidéo en grand format
       */
      $scope.afficherVideo = function(video) {
        $scope.videoSelectionnee = video;
        
        // Créer une URL sécurisée pour l'intégration iframe
        $scope.videoSelectionnee.urlSecurisee = $sce.trustAsResourceUrl(`https://www.youtube.com/embed/${video.videoId}`);
        
        // Ouvrir le modal (Bootstrap 5 API native)
        var el = document.getElementById('modalVideo');
        if (el) bootstrap.Modal.getOrCreateInstance(el).show();
      };
      
      /**
       * Ferme le modal vidéo
       */
      $scope.fermerVideo = function() {
        var el = document.getElementById('modalVideo');
        if (el) { var m = bootstrap.Modal.getInstance(el); if (m) m.hide(); }
        
        // Réinitialiser après la fermeture du modal
        $timeout(function() {
          $scope.videoSelectionnee = null;
        }, 300);
      };
      
      /**
       * Réinitialise les filtres
       */
      $scope.reinitialiserFiltres = function() {
        $scope.filtres = {
          categorie: '',
          texte: '',
          annee: '',
          mois: '',
          duree: '',
          favoris: false
        };
        $scope.filtrerVideos();
      };
      
      /**
       * Basculer l'affichage des favoris uniquement
       */
      $scope.toggleAffichageFavoris = function() {
        $scope.filtres.favoris = !$scope.filtres.favoris;
        $scope.filtrerVideos();
      };
      
      /**
       * Partage la vidéo sur Facebook
       */
      $scope.partagerFacebook = function(video) {
        const url = encodeURIComponent(`https://www.youtube.com/watch?v=${video.videoId}`);
        const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        window.open(shareUrl, '_blank', 'width=600,height=400');
      };
      
      /**
       * Partage la vidéo sur Twitter
       */
      $scope.partagerTwitter = function(video) {
        const url = encodeURIComponent(`https://www.youtube.com/watch?v=${video.videoId}`);
        const texte = encodeURIComponent(`${video.titre} - OTFIP`);
        const shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${texte}`;
        window.open(shareUrl, '_blank', 'width=600,height=400');
      };
      
      /**
       * Partage la vidéo par email
       */
      $scope.partagerEmail = function(video) {
        const url = `https://www.youtube.com/watch?v=${video.videoId}`;
        const sujet = encodeURIComponent(`Vidéo OTFIP: ${video.titre}`);
        const corps = encodeURIComponent(`Découvrez cette vidéo de l'Observatoire Tchadien des Finances Publiques : "${video.titre}"

${video.description}

Lien: ${url}`);
        const mailtoUrl = `mailto:?subject=${sujet}&body=${corps}`;
        window.location.href = mailtoUrl;
      };
    }
  ]);
